import './public_path';
import { VIEWER_OPTIONS } from '../configuration/defaults';
import { PlayerApi } from 'api/player/player_api';
import { normalizeOptions } from 'utilities/parsers';
import { CURRENT_VERSION } from 'utilities/version';

export default class BaseEntryPoint extends PlayerApi {
    constructor(options) {
        super(options);
        this.options = normalizeOptions(Object.assign({}, VIEWER_OPTIONS, options));
        this.initialize(this.options);
    }

    // Extending classes should implement this
    initialize() {}

    destroy() {
        if (this.eventBus) {
            this.eventBus.removeAllListeners();
        }

        if (this.renderer && this.renderer.destroy) {
            this.renderer.destroy();
        }

        return super.destroy();
    }

    get version() {
        return CURRENT_VERSION;
    }
}